import React from 'react';
import classNames from 'classnames';
import { Checkbox as AntCheckbox } from 'antd';
import type { CheckboxProps as AntdCheckboxProps } from 'antd/lib/checkbox';
import cn from './styles.module.scss';

export type CheckboxProps = AntdCheckboxProps;

export function Checkbox({ className, ...props }: CheckboxProps) {
  return (
    <AntCheckbox
      classNames={{ label: cn.label }}
      className={classNames(cn.checkbox, className)}
      {...props}
    />
  );
}
